if (window.location.href.includes("axolt-daily-packs-test")) {
    
} else {
  document.addEventListener('DOMContentLoaded', () => {
    const targetNode = document.querySelector(".product__info-wrapper");
    if (!targetNode) return;

    const formatCurrency = val =>
      new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: Shopify.currency.active
      }).format(val);

    const parseMoneyText = (txt) => {
      if (!txt) return NaN;
      const raw = String(txt)
        .replace(/\u00A0/g, ' ')
        .replace(/[^\d.,\- ]/g, '')
        .trim();
      const hasDot = raw.includes('.');
      const hasComma = raw.includes(',');
      let norm;
      if (hasDot && hasComma) {
        const lastDot = raw.lastIndexOf('.');
        const lastComma = raw.lastIndexOf(',');
        if (lastComma > lastDot) norm = raw.replace(/\./g, '').replace(',', '.');
        else norm = raw.replace(/,/g, '');
      } else if (hasComma && !hasDot) {
        const parts = raw.split(',');
        if (parts[parts.length - 1].length === 2)
          norm = raw.replace(/\./g, '').replace(',', '.');
        else norm = raw.replace(/,/g, '');
      } else {
        norm = raw.replace(/,/g, '');
      }
      norm = norm.replace(/\s+/g, '');
      const n = parseFloat(norm);
      return Number.isFinite(n) ? n : NaN;
    };

    const getMoney = (selector) => {
      const el = document.querySelector(selector);
      return el ? parseMoneyText(el.textContent) : NaN;
    };

    const createEl = (cls, html) => {
      const el = document.createElement('div');
      el.className = cls;
      el.innerHTML = html;
      return el;
    };

    const enhanceSealWidget = () => {
      const priceEl = document.querySelector('.sealsubs-target-element .sls-price .money');
      const extraInfo = document.querySelector('.sealsubs-target-element .sls-selling-plan-group-options');
      if (!priceEl || !extraInfo) return;

      if (extraInfo.querySelector('.extra-info__top') || extraInfo.querySelector('.extra-info__checklist')) {
        observer.disconnect();
        return;
      }

      let subsPrice = getMoney('.sealsubs-target-element .sls-selling-plan-group-price .sls-price .money');
      let oneTimePrice = getMoney('.sealsubs-target-element .sls-one-time-price .sls-price .money');
      let badgeText = null;

      if (
        ["bluebraingames", "terrapino", "8521723", "axlt10", "promeetspro",
        "eur10", "test50", "8846426"].includes(utmCampaign)
      ) {
        const rate = Shopify.currency.rate || 1;
        const fullSubsCalc = subsPrice;
        const fullOneCalc  = oneTimePrice;

        if (["terrapino", "8521723", "promeetspro"].includes(utmCampaign)) {
          subsPrice   = fullSubsCalc - fullSubsCalc * 0.2;
          oneTimePrice = fullOneCalc  - fullOneCalc * 0.2;
          badgeText = "MOST POPULAR – SAVE AN EXTRA 20%";
        } else if (["axlt10", "eur10", "8846426"].includes(utmCampaign)) {
          subsPrice   = fullSubsCalc - fullSubsCalc * 0.1;
          oneTimePrice = fullOneCalc  - fullOneCalc * 0.1;
          badgeText = "MOST POPULAR – SAVE AN EXTRA  10%";
        } else if (utmCampaign === "test50") {
          subsPrice   = fullOneCalc - fullOneCalc * 0.5;
          oneTimePrice = fullOneCalc;
          badgeText = "MOST POPULAR – SAVE AN EXTRA 50%";
        } else {
          subsPrice   = fullSubsCalc - rate * 10;
          oneTimePrice = fullOneCalc - rate * 10;
          badgeText = "MOST POPULAR – SAVE AN EXTRA $10";
        }

        const subsEl = document.querySelector('.sealsubs-target-element .sls-selling-plan-group-price .sls-price .money');
        const oneEl  = document.querySelector('.sealsubs-target-element .sls-one-time-price .sls-price .money');
        if (subsEl && Number.isFinite(subsPrice)) subsEl.textContent = formatCurrency(subsPrice);
        if (oneEl && Number.isFinite(oneTimePrice)) oneEl.textContent = formatCurrency(oneTimePrice);
      }

      const perServing = (val) => Number.isFinite(val) ? formatCurrency(val / 30) : null;
      const discSubsServingPrice = perServing(subsPrice);
      const discOneServingPrice  = perServing(oneTimePrice);

      const savingsBadge = document.querySelector('.sls-savings-badge');
      if (savingsBadge) {
        savingsBadge.textContent = badgeText || "MOST POPULAR";
      }

      if (["andy", "8031529"].includes(utmCampaign)) {
        extraInfo.innerHTML = '<p style="margin:3px 0;color:#636363;">Pay $109 now, then $119/month</p>';
      } else {
        const perText = discSubsServingPrice ? ` (${discSubsServingPrice} / serving)` : '';
        const extraTop = createEl('extra-info__top', `<div>30 servings${perText}</div>`);
        extraInfo.querySelector('.selling-plan-group-options-name-select')?.style.setProperty('display', 'none');
        extraInfo.append(extraTop);
      }

      const checklistItems = [
        'Free Premium Axolt Glass Shaker',
        'Pause, skip or cancel any time',
        'Free shipping',
        '100% Money Back Guarantee'
      ];
      const checklistHTML = checklistItems.map(text =>
        `<p style="margin:0;color:#636363;">
          <svg style="margin-right:5px;" width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 3.85L2.65 5.5c.2.2.52.2.7 0L7.5 1.35" stroke="#A1151C" stroke-width="1.5"/>
          </svg>${text}
        </p>`
      ).join('');
      extraInfo.insertAdjacentHTML('beforeend', `<div class="extra-info__checklist">${checklistHTML}</div>`);

      document.querySelector('.sls-more-info-container')?.remove();

      if (!["andy", "8031529", "bluebraingames"].includes(utmCampaign)) {
        const oneTimeContainer = document.querySelector('.sls-one-time-price')?.closest('.seal-col');
        if (oneTimeContainer && !oneTimeContainer.querySelector('.ot-daily-price') && discOneServingPrice) {
          const otExtraTop = createEl('extra-info__top', `
            <div>30 servings shipped once (${discOneServingPrice} / serving)</div>
          `);
          const otGroupOps = createEl('sls-selling-plan-group-options', otExtraTop.outerHTML);
          oneTimeContainer.append(otGroupOps);
        }

        if (!document.querySelector('.extra-info__quantity')) {
          const qtySection = document.createElement('div');
          qtySection.className = 'extra-info__quantity';
          qtySection.innerHTML = `
            <div>You've selected a one-time purchase. Save 4% per additional box.</div>
            <div class="quantity-control">
              <div class="quantity-stepper">
                <button type="button" class="qty-minus" aria-label="Decrease">−</button>
                <input type="number" id="quantity" name="quantity" value="1" min="1">
                <button type="button" class="qty-plus" aria-label="Increase">+</button>
              </div>
              <div class="quantity-total">Total: <span class="total-value"></span></div>
            </div>
          `;

          const oneTimeGroup = oneTimeContainer.querySelector('.sls-selling-plan-group-options');
          (oneTimeGroup || oneTimeContainer).append(qtySection);

          const basePrice = oneTimePrice || 0;
          const totalEl = qtySection.querySelector('.total-value');
          const input = qtySection.querySelector('#quantity');

          const updateTotal = () => {
            let qty = Math.max(1, parseInt(input.value) || 1);
            const discountRate = Math.min(0.04 * (qty - 1), 0.20);
            const effectiveTotal = basePrice * qty * (1 - discountRate);
            totalEl.textContent = formatCurrency(effectiveTotal);
          };

          qtySection.querySelector('.qty-minus').addEventListener('click', () => {
            if (input.value > 1) input.value--;
            updateTotal();
          });

          qtySection.querySelector('.qty-plus').addEventListener('click', () => {
            input.value++;
            updateTotal();
          });

          input.addEventListener('input', updateTotal);
          updateTotal();
        }
      }

      observer.disconnect();
    };

    const observer = new MutationObserver(() => {
      clearTimeout(observer._timeout);
      observer._timeout = setTimeout(enhanceSealWidget, 300);
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  });
}